import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpResponse, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable, throwError, from } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { CookiesStorage } from './cookies-storage.service';
import { AppTranslateService } from './app-translate.service';
import { ToastrAlertService } from './toastr.service';
import { UserProfileService } from '../userProfile.service';
import { Router } from '@angular/router';
import { LoaderService } from '../loader.service';
import { environment } from 'src/environments/environment';



@Injectable({
  providedIn: 'root'
})

export class HttpConfigInterceptor implements HttpInterceptor {

  constructor(
    private loaderService: LoaderService,
    private toastrAlertService: ToastrAlertService,
    private appTranslateService: AppTranslateService,
    private userProfileService: UserProfileService,
    private router: Router
  ) { }


  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token: string = CookiesStorage.getCookie('accessToken');

    if (token) {
      request = request.clone({ headers: request.headers.set('Authorization', 'Bearer ' + token) });
    }

    if (!request.headers.has('Content-Type') && request.url.indexOf("Upload") == -1 && request.url.indexOf("DownloadAttachment") == -1) {
      request = request.clone({ headers: request.headers.set('Content-Type', 'application/json') });
    }
    if (request.url.indexOf("DownloadAttachment") !== -1) {
      request = request.clone({ headers: request.headers.set('Content-Type', 'application/octet') });
      request = request.clone({ headers: request.headers.set('Accept', 'application/octet') });
    }
    if (request.url.indexOf("Upload") == -1 && request.url.indexOf("DownloadAttachment") == -1)
      request = request.clone({ headers: request.headers.set('Accept', 'application/json') });

    var lang = localStorage.getItem('lang');
    request = request.clone({ headers: request.headers.set('CultureLanguage', (!lang || lang === null || lang === "" ? "en" : lang)) });

    request = request.clone({ headers: request.headers.set('Version', environment.Version) });

    request = request.clone({ headers: request.headers.set('Type', 'Web') });

    //   this.spinner.show();

    return next.handle(request).pipe(//retry(2),
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          //this.spinner.hide();
        }
        return event;
      }),
      catchError(this.handleError('', [])))
  }
  private handleError<T>(operation = 'operation', result?: any) {
    return (error: any): Observable<any> => {
      this.loaderService.customhide();
      switch (error.status) {

        case 0: {
          this.toastrAlertService.errorToastr(this.appTranslateService.getTranslate("cannotConnectToTheService"));
          break;
        }
        case 401: {
          this.toastrAlertService.errorToastr(this.appTranslateService.getTranslate("unauthorizedRequest"));
          // redirect to login.
          this.userProfileService.clearProfile();
          this.router.navigate(['/account/login']);
          break;
        }
        case 404: {
          this.toastrAlertService.errorToastr(this.appTranslateService.getTranslate("requestNotFound"));
          break;
        }

        case 500: {
          this.toastrAlertService.errorToastr(this.appTranslateService.getTranslate("generalError"));
          break;
        }

        case 412: {
          this.toastrAlertService.errorToastr(this.appTranslateService.getTranslate("generalError"))
        }

        default: {
          this.toastrAlertService.errorToastr(this.appTranslateService.getTranslate("generalError"))
        }
      }
      console.error('HttpInterceptor -->> ERROR --->>: ', error);
      //this.spinner.hide();
      return throwError(error.error);
    };
  }
}
